import { render } from "./PolicyOnboardComponent.vue?vue&type=template&id=6ce9e16c"
import script from "./PolicyOnboardComponent.vue?vue&type=script&lang=js"
export * from "./PolicyOnboardComponent.vue?vue&type=script&lang=js"

import "./PolicyOnboardComponent.vue?vue&type=style&index=0&id=6ce9e16c&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__